import React from "react"
import Img from "gatsby-image"
import { FaFacebookF, FaInstagram } from "react-icons/fa"
import PropTypes from "prop-types"

// Styles
import styles from "../styles/components/trainer.module.scss"

const Trainer = ({
  image,
  name,
  qualification1,
  qualification2,
  fb,
  insta,
}) => (
  <div className={styles.trainer}>
    <div className={styles.image}>
      <Img fluid={image} alt={name} />
    </div>
    <div className={styles.info}>
      <p className={styles.name}>{name}</p>

      <p className={styles.qualifications}>{qualification1}</p>
      <p className={styles.qualifications}>{qualification2}</p>

      <div className={styles.social}>
        {fb && <a aria-label={`${name} on Facebook`} href={fb} target="_blank" rel="noopener noreferrer">
          <FaFacebookF />
        </a>}
        {insta && <a aria-label={`${name} on Instagram`} href={insta} target="_blank" rel="noopener noreferrer">
          <FaInstagram />
        </a>}
      </div>
    </div>
  </div>
)

export default Trainer

Trainer.defaultProps = {
  fb: null,
  insta: null,
}

Trainer.propTypes = {
  fb: PropTypes.string,
  insta: PropTypes.string,
}
